<!-- status-badge.component.html -->
<div class="flex items-center" [ngClass]="className">
    <div class="w-3 h-3 rounded-full" [ngClass]="config.bgColor"></div>
    <span *ngIf="showLabel" class="ml-2 text-base font-semibold">
        {{ config.label }}
    </span>
</div>
